// Utilitário para inicializar e gerenciar o Keycloak
// Adapte conforme necessário para seu fluxo de autenticação

const keycloakConfig =
    process.env.REACT_APP_KEYCLOAK_JSON || '/keycloak-qa.json';

const keycloak = new window.Keycloak(keycloakConfig);

export function initKeycloak(onAuthenticatedCallback) {
    keycloak
        .init({
            onLoad: 'login-required',
            checkLoginIframe: false,
            promiseType: 'native',
        })
        .then((authenticated) => {
            if (authenticated) {
                onAuthenticatedCallback();
            } else {
                window.location.reload();
            }
        });
}

export function getKeycloak() {
    return keycloak;
}

export function getToken() {
    return keycloak.token;
}

export function getUserProfile() {
    return keycloak.tokenParsed || {};
}

export function doLogout() {
    keycloak.logout();
}
